/**
 * Client calls for the user-authored (custom) integration magic-link flow.
 *
 * Every call passes `throwOnError: true` and lets the axios error through, so
 * the page can show it with `getUserFacingApiErrorMessage`. A 4xx returned as
 * an ordinary result made a rejected credential show "All set" (GET-18350).
 * secretRequestApis.sim.test.ts pins it.
 */

import {
  getCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGet,
  submitCustomSecretsApiV1IntegrationsCustomSecretsPost,
  type GetCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGetResponses,
  type SubmitCustomSecretsApiV1IntegrationsCustomSecretsPostResponses,
} from "../client";

export type CustomSecretRequestDetails =
  GetCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGetResponses[200];

export type CustomSecretSubmitResponse =
  SubmitCustomSecretsApiV1IntegrationsCustomSecretsPostResponses[200];

export async function getCustomSecretRequestDetails(
  token: string,
): Promise<CustomSecretRequestDetails> {
  const response =
    await getCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGet({
      path: { token },
      throwOnError: true,
    });
  return response.data;
}

export async function submitCustomSecrets(
  token: string,
  values: Record<string, string>,
): Promise<CustomSecretSubmitResponse> {
  const response = await submitCustomSecretsApiV1IntegrationsCustomSecretsPost({
    body: { token, values },
    throwOnError: true,
  });
  return response.data;
}
